<template>
  <div class="c-bonus">
    <div class="wrap py-24 h-3/4">
    <div class="text-center">
        <div v-if="textSolutionForm" v-html="textSolutionForm.body"></div>
       <h2 v-else>
           Ontwar de overgebleven letters
       </h2>

       <PuzzleSolutionGrid :word="bonusWordScrambled"/>

       <p class="my-16">
           Hint: {{ bonusItem.tip }}
       </p>

       <form @submit.prevent="validateSolution">
           <FieldInput
                  :fieldId="fieldSolution.name"
                  :label="fieldSolution.label"
                  :value="fieldSolution.value"
                  :required="fieldSolution.required"
                  :name="fieldSolution.name"
                  :placeholder="fieldSolution.placeholder"
                  :type="fieldSolution.type"
                  :rule="fieldSolution.rule"
                  :module="module"
                  :subform="subform"
                  :error="fieldSolution.error"
                  :formError="form.error"
          />

          <button class="c-button w-full mt-8">
            Oplossing bevestigen
          </button>
  
          <div v-if="errorMessage">
              <p class="mt-8 text-red">{{ errorMessage }}</p>
          </div>
       </form>

    </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { find, shuffle } from 'lodash'

  import PuzzleSolutionGrid from '@/components/puzzle/PuzzleSolutionGrid'
  import FieldInput from '@/components/forms/FieldInput'

  export default {
    name: 'PuzzleSolutionForm',

    data () {
      return {
        module: 'admin',
        subform: 'solutionForm',
        errorMessage: null
      }
    },

    methods: {
      validateSolution () {
        this.errorMessage = null
        const module = this.module
        const subform = this.subform

        this.$store.dispatch('forms/validateForm', { module, subform })

        const solution = this.fieldSolution.value

        if (solution.toLowerCase() !== this.bonusWord.toLowerCase()) {
          this.errorMessage = 'Deze oplossing is niet correct. Probeer het nog een keer'
          return
        }

        this.$store.commit('addFoundWordId', { word_id: this.bonusItem.id })
      }
    },

    computed: {
      ...mapState({
        puzzle: state => state.currentPuzzle,
        gridSettings: state => state.gridSettings
      }),

      // Dirty fix: our current form validation setup doesn't support forms in rootState
      ...mapState('admin', {
        form: state => state.solutionForm.form,
        fieldSolution: state => state.solutionForm.form.fields.solution
      }),

      bonusItem () {
        return find(this.puzzle.words, item => item.is_bonus)
      },

      bonusWord () {
        const item = this.bonusItem

        if (!item) {
          return null
        }

        return item.word
      },

      bonusWordScrambled () {
        const bonusWord = this.bonusWord.toLowerCase()
        let bonusWordScrambled = bonusWord

        while(bonusWord === bonusWordScrambled) {
          bonusWordScrambled = shuffle(bonusWord).join('')
        }

        return bonusWordScrambled
      },

      textSolutionForm () {
        return this.$store.getters.textByRealm({ realm: 'solution_form' })
      }
    },

    components: {
      PuzzleSolutionGrid,
      FieldInput
    }
  }
</script>
